"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Drawer_1 = require("@mui/material/Drawer");
var AppBar_1 = require("@mui/material/AppBar");
var Toolbar_1 = require("@mui/material/Toolbar");
var List_1 = require("@mui/material/List");
var CssBaseline_1 = require("@mui/material/CssBaseline");
var Divider_1 = require("@mui/material/Divider");
var Menu_1 = require("@mui/icons-material/Menu");
var ChevronLeft_1 = require("@mui/icons-material/ChevronLeft");
var ChevronRight_1 = require("@mui/icons-material/ChevronRight");
var ListItem_1 = require("@mui/material/ListItem");
var ListItemButton_1 = require("@mui/material/ListItemButton");
var ListItemIcon_1 = require("@mui/material/ListItemIcon");
var ListItemText_1 = require("@mui/material/ListItemText");
var Person_1 = require("@mui/icons-material/Person");
var Newspaper_1 = require("@mui/icons-material/Newspaper");
var CalendarToday_1 = require("@mui/icons-material/CalendarToday");
var IconButton_1 = require("@mui/material/IconButton");
var Typography_1 = require("@mui/material/Typography");
var Warning_1 = require("@mui/icons-material/Warning");
var People_1 = require("@mui/icons-material/People");
var Map_1 = require("@mui/icons-material/Map");
var ContactMail_1 = require("@mui/icons-material/ContactMail");
var Logout_1 = require("@mui/icons-material/Logout");
var BulletinBoard_1 = require("./BulletinBoard");
var Calendar_1 = require("./Calendar");
var Sponsors_1 = require("./Sponsors");
var Suggestions_1 = require("./Suggestions");
var Documents_1 = require("./Documents");
var AddSuggestion_1 = require("./AddSuggestion");
var Admin_1 = require("./Admin");
var StorageService_1 = require("../shared/storage/StorageService");
var StorageKeys_1 = require("../shared/storage/StorageKeys");
var history_1 = require("history");
var Role_1 = require("../shared/utilities/Role");
var material_1 = require("@mui/material");
var drawerWidth = 240;
var openedMixin = function (theme) { return ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: "hidden"
}); };
var closedMixin = function (theme) {
    var _a;
    return (_a = {
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            overflowX: "hidden",
            width: "calc(" + theme.spacing(7) + " + 1px)"
        },
        _a[theme.breakpoints.up("sm")] = {
            width: "calc(" + theme.spacing(8) + " + 1px)"
        },
        _a);
};
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var AppBar = styles_1.styled(AppBar_1.default, {
    shouldForwardProp: function (prop) { return prop !== "open"; }
})(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign({ zIndex: theme.zIndex.drawer + 1, transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }) }, (open && {
        marginLeft: drawerWidth,
        width: "calc(100% - " + drawerWidth + "px)",
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    })));
});
var Drawer = styles_1.styled(Drawer_1.default, {
    shouldForwardProp: function (prop) { return prop !== "open"; }
})(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign(__assign({ width: drawerWidth, flexShrink: 0, whiteSpace: "nowrap", boxSizing: "border-box" }, (open && __assign(__assign({}, openedMixin(theme)), { "& .MuiDrawer-paper": openedMixin(theme) }))), (!open && __assign(__assign({}, closedMixin(theme)), { "& .MuiDrawer-paper": closedMixin(theme) }))));
});
function MiniDrawer() {
    var _this = this;
    var _a = React.useState(0), currentPageNumber = _a[0], setCurrentPageNumber = _a[1];
    var _b = React.useState('Bulletin Board'), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = React.useState(false), isMobile = _c[0], setIsMobile = _c[1];
    var _d = React.useState(false), hasToken = _d[0], setHasToken = _d[1];
    var Pages = ["Bulletin Board", "Events Calendar", "Things YOU Need to Know!", "Maps", "Sponsors", "Suggestions"];
    ;
    var role = Role_1.default();
    var handleIconClickEvent = function (newPage) {
        console.log('setting new page', newPage);
        setCurrentPageNumber(Pages.indexOf(newPage));
        setCurrentPage(newPage);
    };
    var theme = styles_1.useTheme();
    var _e = React.useState(true), open = _e[0], setOpen = _e[1];
    var handleDrawerOpen = function () {
        setOpen(true);
    };
    var handleDrawerClose = function () {
        setOpen(false);
    };
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
            setOpen(false);
        }
        else {
            setIsMobile(false);
        }
    };
    React.useEffect(function () {
        StorageService_1.default.get(StorageKeys_1.Auth.Token).then(function (result) {
            if (result != null) {
                setHasToken(true);
            }
            else {
                window.location.href = '/login';
            }
        });
        window.addEventListener("resize", handleResize);
        handleResize();
    }, []);
    return (React.createElement(Box_1.default, { sx: { display: "flex" } }, hasToken && React.createElement(React.Fragment, null,
        React.createElement(CssBaseline_1.default, null),
        React.createElement(AppBar, { position: "fixed", open: open },
            React.createElement(Toolbar_1.default, { style: { justifyContent: "space-between" } },
                React.createElement(IconButton_1.default, { color: "inherit", "aria-label": "open drawer", onClick: handleDrawerOpen, edge: "start", sx: {
                        marginRight: 5,
                    } }, !isMobile && !open &&
                    React.createElement(Menu_1.default, null)),
                React.createElement(Typography_1.default, { variant: "h6", noWrap: true, component: "div" }, currentPage),
                React.createElement(Typography_1.default, { variant: "h5", align: "center", sx: { minWidth: 80 } },
                    React.createElement(IconButton_1.default, { color: "inherit", "aria-label": "open drawer", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, StorageService_1.default.remove(StorageKeys_1.Auth.Token)];
                                    case 1:
                                        _a.sent();
                                        history_1.createBrowserHistory().push('/login');
                                        window.location.reload();
                                        return [2 /*return*/, true];
                                }
                            });
                        }); }, edge: "end", style: { float: 'right' } },
                        React.createElement(Logout_1.default, null)),
                    role === 'Admin' &&
                        React.createElement(IconButton_1.default, { color: "inherit", "aria-label": "Admin", onClick: function () { setCurrentPage('Admin'); }, edge: "end", style: { float: 'right', marginRight: '10px' } },
                            React.createElement(Person_1.default, null))))),
        !isMobile &&
            React.createElement(Drawer, { variant: "permanent", open: open },
                React.createElement(DrawerHeader, null,
                    React.createElement(IconButton_1.default, { onClick: handleDrawerClose }, theme.direction === "rtl" ? (React.createElement(ChevronRight_1.default, null)) : (React.createElement(ChevronLeft_1.default, null)))),
                React.createElement(Divider_1.default, null),
                React.createElement(List_1.default, null, ["Bulletin Board", "Events Calendar"].map(function (text, index) { return (React.createElement(ListItem_1.default, { key: text, disablePadding: true, sx: { display: "block" } },
                    React.createElement(ListItemButton_1.default, { sx: {
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5
                        }, onClick: function () { handleIconClickEvent(text); } },
                        React.createElement(ListItemIcon_1.default, { sx: {
                                minWidth: 0,
                                mr: open ? 3 : "auto",
                                justifyContent: "center"
                            } }, index % 2 === 0 ? React.createElement(Newspaper_1.default, null) : React.createElement(CalendarToday_1.default, null)),
                        React.createElement(ListItemText_1.default, { className: "drawerLabels", primary: text, sx: { opacity: open ? 1 : 0 } })))); })),
                React.createElement(Divider_1.default, null),
                React.createElement(List_1.default, null, ["Things YOU Need to Know!", "Maps", "Sponsors", "Suggestions"].map(function (text, index) { return (React.createElement(ListItem_1.default, { key: text, disablePadding: true, sx: { display: "block" } },
                    React.createElement(ListItemButton_1.default, { sx: {
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5
                        }, onClick: function () {
                            handleIconClickEvent(text);
                        } },
                        React.createElement(ListItemIcon_1.default, { sx: {
                                minWidth: 0,
                                mr: open ? 3 : "auto",
                                justifyContent: "center"
                            } },
                            text == "Things YOU Need to Know!" ? React.createElement(Warning_1.default, null) : React.createElement(React.Fragment, null),
                            text == "Maps" ? React.createElement(Map_1.default, null) : React.createElement(React.Fragment, null),
                            text == "Sponsors" ? React.createElement(People_1.default, null) : React.createElement(React.Fragment, null),
                            text == "Suggestions" ? React.createElement(ContactMail_1.default, null) : React.createElement(React.Fragment, null)),
                        React.createElement(ListItemText_1.default, { className: "drawerLabels", primary: text, sx: { opacity: open ? 1 : 0 } })))); }))),
        currentPage == 'Bulletin Board' ? React.createElement(BulletinBoard_1.default, null) : React.createElement(React.Fragment, null),
        currentPage == 'Events Calendar' ? React.createElement(Calendar_1.default, null) : React.createElement(React.Fragment, null),
        currentPage == 'Things YOU Need to Know!' ? React.createElement(Documents_1.default, { type: "Emergency" }) : React.createElement(React.Fragment, null),
        currentPage == 'Maps' ? React.createElement(Documents_1.default, { type: "Maps" }) : React.createElement(React.Fragment, null),
        currentPage == 'Sponsors' ? React.createElement(Sponsors_1.default, null) : React.createElement(React.Fragment, null),
        currentPage == 'Suggestions' && role === 'Admin' ? React.createElement(Suggestions_1.default, null) : React.createElement(React.Fragment, null),
        currentPage == 'Suggestions' && role !== 'Admin' ? React.createElement(AddSuggestion_1.default, null) : React.createElement(React.Fragment, null),
        currentPage == 'Admin' ? React.createElement(Admin_1.default, null) : React.createElement(React.Fragment, null),
        isMobile &&
            React.createElement(material_1.Paper, { sx: { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2000 }, elevation: 3 },
                React.createElement(material_1.BottomNavigation, { showLabels: true, value: currentPageNumber, onChange: function (event, newValue) {
                        console.log(event);
                        handleIconClickEvent(Pages[newValue]);
                    } },
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(Newspaper_1.default, null), sx: { minWidth: '30px' } }),
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(CalendarToday_1.default, null), sx: { minWidth: '30px' } }),
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(Warning_1.default, null), sx: { minWidth: '30px' } }),
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(Map_1.default, null), sx: { minWidth: '30px' } }),
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(People_1.default, null), sx: { minWidth: '30px' } }),
                    React.createElement(material_1.BottomNavigationAction, { icon: React.createElement(ContactMail_1.default, null), sx: { minWidth: '30px' } }))))));
}
exports.default = MiniDrawer;
//# sourceMappingURL=MiniDrawer.js.map